/* Auto table-of-contents for the gm-policy section.
   Scans the rendered page content for headings, assigns ids, builds the
   sidebar list, and (optionally) highlights the active section on scroll. */
(function () {
  if (customElements.get('gm-policy-toc')) return;

  function slugify(text, fallback) {
    var slug = (text || '')
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
    return slug || 'section-' + fallback;
  }

  class GmPolicyToc extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-gm-policy-content]');
      this.list = this.querySelector('[data-gm-policy-toc]');
      this.sidebar = this.querySelector('[data-gm-policy-sidebar]');
      if (!this.content || !this.list) return;

      var levels = this.dataset.tocLevels === 'h2h3' ? 'h2, h3' : 'h2';
      this.headings = Array.prototype.slice.call(this.content.querySelectorAll(levels));

      if (!this.headings.length) {
        this.classList.add('gm-policy--no-toc');
        return;
      }

      this.buildList();

      if (this.dataset.scrollspy === 'true') {
        this.setupScrollSpy();
      }
    }

    buildList() {
      var seen = {};
      var frag = document.createDocumentFragment();
      this.links = [];

      this.headings.forEach(function (heading, index) {
        var id = heading.id;
        if (!id) {
          id = slugify(heading.textContent, index);
          while (seen[id] || document.getElementById(id)) {
            id = id + '-' + index;
          }
          heading.id = id;
        }
        seen[id] = true;

        var item = document.createElement('li');
        item.className = 'gm-policy__toc-item gm-policy__toc-item--' + heading.tagName.toLowerCase();

        var link = document.createElement('a');
        link.className = 'gm-policy__toc-link';
        link.href = '#' + id;
        link.textContent = heading.textContent;

        item.appendChild(link);
        frag.appendChild(item);

        this.links.push({ item: item, heading: heading });
      }, this);

      this.list.appendChild(frag);
    }

    setupScrollSpy() {
      if (!('IntersectionObserver' in window)) return;
      var self = this;

      this.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            self.links.forEach(function (link) {
              link.item.classList.toggle('is-active', link.heading === entry.target);
            });
          });
        },
        { rootMargin: '-15% 0px -75% 0px', threshold: 0 }
      );

      this.headings.forEach(function (heading) {
        self.observer.observe(heading);
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('gm-policy-toc', GmPolicyToc);
})();
